import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { materialsActions } from '../actions/materials.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class MaterialsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getMaterials$ = createEffect(() => {
        return this.actions.pipe(
            ofType(materialsActions.getMaterials),
            switchMap(({ value }) => {
                return this.httpService.getMaterials(value).pipe(
                    map((payload) => materialsActions.getMaterialsSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(materialsActions.getMaterialsError({ code: error.status }))),
                );
            }),
        );
    });

    getMaterialsLookup$ = createEffect(() => {
        return this.actions.pipe(
            ofType(materialsActions.getMaterialsLookup),
            switchMap(() => {
                return this.httpService.getMaterialsLookup().pipe(
                    map((payload) => materialsActions.getMaterialsLookupSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(materialsActions.getMaterialsLookupError({ code: error.status }))),
                );
            }),
        );
    });
}
